<template>
  <div>
  <el-tag
    :key="tag.id"
    v-for="tag in programs"
    closable
    :disable-transitions="false"
    @close="handleClose(tag)">
    {{tag.name}}
  </el-tag>
  <el-input
    class="input-new-tag"
    v-if="inputVisible"
    v-model="inputValue"
    ref="saveTagInput"
    size="mini"
    @keyup.enter.native="handleInputConfirm"
    @blur="handleInputConfirm"
  >
  </el-input>
  <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Program</el-button>
  </div>
</template>

<script>
import {database} from '../main.js'
import {getProgramsMixin} from './getProgramsMixin.js'
export default {
  props: ['contractId'],
  mixins: [getProgramsMixin],
  data () {
    return {
      id: this.contractId,
      inputVisible: false,
      inputValue: ''
    };
  },
  created () {
    this.getPrograms(this.id)
  },
  methods: {
    handleClose (tag) {
      database.ref(`contracts/${this.id}/programs/${tag.id}`).set(null)
      database.ref(`programs/${tag.id}`).update({legacy: true})
    },

    showInput () {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    async handleInputConfirm () {
      let inputValue = this.inputValue;
      if (inputValue) {
        const newProgram = await database.ref('/programs').push()
        const programId = newProgram.key
        database.ref(`/contracts/${this.id}/programs/${programId}`).set(true)
        newProgram.set({
            name: inputValue,
            contract: this.id
          })
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  }
};
</script>

<style>
  .el-tag {
    margin-right: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProgramTags.vue